module.exports = __webpack_public_path__ + "static/img/bsd.cd4561f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course/bsd.jpg
// module id = pec4
// module chunks = 0